import client from "../client";

export const getAllAnalysisProjects = async ({ search }) => {
  return await client.get(`/image-analysis/projects?search=${search}`);
};
export const getAnalysisProjectDetailsById = async ({ id }) => {
  return await client.get(`image-analysis/projects/${id}`);
};

export const createAnalysisProject = async ({ payload }) => {
  return await client.post("/image-analysis/projects", payload);
};

export const addJsonToAnalysisProject = async ({ id, json }) => {
  return await client.post(`/image-analysis/projects/analysis/${id}`, json);
};

export const deleteAnalysisProject = async ({ id }) => {
  return await client.delete(`/image-analysis/projects/${id}`);
};
export const addThumbnailToProject = async ({ formData }) => {
  return await client.post(`/image-analysis/projects/thumbnail`, formData);
};
